var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartoComponentsLogoNegativeSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.043 40C31.065 40 40 31.046 40 20S31.065 0 20.043 0C9.022 0 .087 8.954.087 20s8.935 20 19.956 20z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.043,
    cy: 20,
    rx: 6.652,
    ry: 6.667
  }))));
}

export default __webpack_public_path__ + "e7e90910b3a3a56951dde9346cac0a45.svg";
export { SvgCartoComponentsLogoNegativeSymbol as ReactComponent };